module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// D:/Projects/dev/peer/client/node_modules/readable-stream/passthrough.js
// module id = 762
// module chunks = 0